import classNames from 'classnames';
import { Button } from 'components/Button';
import EditorialSection from 'components/EditorialSection';
import Section from 'components/Section';
import { Transition } from 'react-transition-group';
import { reflow } from 'utils/transition';
import './Profile.css';

const Profile = ({ id, visible, sectionRef }) => {
  const titleId = `${id}-title`;

  return (
    <Section
      className="profile"
      as="section"
      id={id}
      ref={sectionRef}
      aria-labelledby={titleId}
      tabIndex={-1}
    >
      <Transition in={visible} timeout={0} onEnter={reflow}>
        {status => (
          <div className="profile__content">
            <EditorialSection
              index={0}
              eyebrow="About"
              title="Engineer, end to end."
              headingId={titleId}
              className={classNames('profile__header', `profile__header--${status}`)}
            />
            <p className={classNames('profile__lede', `profile__lede--${status}`)}>
              Hi, I'm Sébastien — a full-stack engineer based in Paris, shipping
              React, Next.js and React-Native products end-to-end as a freelance
              engineer, from first mockup to production.
            </p>
            <Button
              secondary
              className={classNames('profile__button', `profile__button--${status}`)}
              href="https://www.linkedin.com/in/sebastien-friedberg/"
              icon="send"
            >
              Contact me on LinkedIn
            </Button>
          </div>
        )}
      </Transition>
    </Section>
  );
};

export default Profile;
